const timeFormat = new Intl.RelativeTimeFormat([], {
  numeric: "auto",
  style: "long",
});

const secondsInMinute = 60;
const secondsInHour = 60 * secondsInMinute;
const secondsInDay = 24 * secondsInHour;
const secondsInMonth = 30 * secondsInDay;
const secondsInYear = 365 * secondsInDay;

function getFormatUnits(date) {
  var seconds = (date.getTime() - new Date().getTime()) / 1000;
  var sizes = [secondsInYear, secondsInMonth, secondsInDay, secondsInHour, secondsInMinute];
  var units = ["year", "month", "day", "hour", "minute"];

  for (var i = 0; i < sizes.length; i++) {
    if (Math.abs(seconds) >= sizes[i]) {
      return [Math.round(seconds / sizes[i]), units[i]];
    }
  }
  return [seconds, "seconds"];
}

export function FormattedDateRelative({ date }) {
  var [value, unit] = getFormatUnits(date);
  return timeFormat.format(value, unit);
}
